import { render, staticRenderFns } from "./PuzzleGame.vue?vue&type=template&id=3f7b02a4&scoped=true&"
import script from "./PuzzleGame.vue?vue&type=script&lang=ts&"
export * from "./PuzzleGame.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleGame.vue?vue&type=style&index=0&id=3f7b02a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b02a4",
  null
  
)

export default component.exports